// DSG-001 compliant — semantic tokens only.
export default function PageHeader({ title, description, actions, rightSlot }) {
  const rhs = actions || rightSlot;
  return (
    <div
      data-testid="page-header"
      className="mb-8 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between"
    >
      <div>
        <h1 className="font-display text-3xl font-semibold tracking-tight text-charcoal">
          {title}
        </h1>
        {description && (
          <p className="mt-1.5 max-w-2xl text-[15px] text-ink-secondary">
            {description}
          </p>
        )}
      </div>
      {rhs && <div className="flex flex-wrap items-center gap-2">{rhs}</div>}
    </div>
  );
}
